/* ==========================================================================
   sz-happy-customers.js — CHỈ chạy trên /pages/reviews (Judge.me all_reviews_page)
   AI Agent làm theo chỉ thị của anh Hoá — 2026-09-16 VN — WEB-20260916-suzitee-happy-customers
   Đã làm: nâng độ nét ảnh review trong lưới card mới. Judge.me render thumbnail
   ở ?width=160 (đủ cho ô 94px cũ, vỡ nét ở ô ~334px màn Retina). Script lấy ĐÚNG
   ảnh gốc đó trên CDN Judge.me rồi xin lại đúng bề rộng cần (ô hiển thị × DPR,
   làm tròn lên bậc 160px, trần 1400) — KHÔNG đổi ảnh, KHÔNG bịa ảnh, KHÔNG đụng
   data-mfp-src của lightbox. Thêm gợi ý vuốt cho card có nhiều hơn 1 ảnh.

   Kỷ luật (bài học r10): KHÔNG MutationObserver trên body/subtree rộng; chỉ
   querySelectorAll một lần + rAF; resize có debounce và chỉ chạy lại khi bậc
   bề rộng thật sự đổi; toàn bộ bọc try/catch để không bao giờ chặn Judge.me.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('judgeme_all_reviews_page');
  if (!root) return;                       // chốt an toàn: không phải trang all-reviews thì thoát

  var STEP = 160;
  var MAX = 1400;
  var lastBucket = 0;

  function bucketFor(px) {
    var dpr = window.devicePixelRatio || 1;
    var want = Math.ceil((px * dpr) / STEP) * STEP;
    if (want < STEP) want = STEP;
    if (want > MAX) want = MAX;
    return want;
  }

  function withWidth(url, w) {
    if (!url) return null;
    // chỉ đổi tham số width trên CDN ảnh review của Judge.me, không đụng host khác
    if (url.indexOf('review-images.judgeme.com') === -1) return null;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function sharpen() {
    var links = root.querySelectorAll('.jdgm-rev__pics > .jdgm-rev__pic-link');
    if (!links.length) return;

    var probe = links[0].getBoundingClientRect().width;
    if (!probe) return;
    var bucket = bucketFor(probe);
    if (bucket === lastBucket) return;      // không đổi bậc -> không làm gì (tránh tự kích)
    lastBucket = bucket;

    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var img = a.querySelector('.jdgm-rev__pic-img');
      if (!img) continue;
      // nguồn gốc: href / data-mfp-src của thẻ a (ảnh gốc cùng review), fallback src hiện có
      var base = a.getAttribute('data-mfp-src') || a.getAttribute('href') ||
                 img.getAttribute('data-src') || img.getAttribute('src');
      var next = withWidth(base, bucket);
      if (!next) continue;
      if (img.getAttribute('data-src')) img.setAttribute('data-src', next);
      if (img.getAttribute('src') !== next) img.setAttribute('src', next);
      if (!img.getAttribute('loading')) img.setAttribute('loading', 'lazy');
      if (!img.getAttribute('decoding')) img.setAttribute('decoding', 'async');
    }
  }

  // ROUND 2 — tham chiếu Almagems KHÔNG có badge đếm ảnh / vuốt ngang.
  // Bỏ hẳn: chỉ dọn lại attribute cũ nếu còn sót từ bản trước.
  function markMulti() {
    var pics = root.querySelectorAll('.jdgm-rev__pics[data-sz-count]');
    for (var i = 0; i < pics.length; i++) pics[i].removeAttribute('data-sz-count');
  }

  function run() {
    try { sharpen(); markMulti(); } catch (e) { /* không bao giờ chặn Judge.me */ }
  }

  function schedule() { window.requestAnimationFrame(run); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  // Judge.me hoán data-src -> src sau khi widget dựng xong: chạy lại vài nhịp thưa, có giới hạn
  var retries = 0;
  var t = setInterval(function () {
    retries++;
    lastBucket = 0;           // ép tính lại sau khi widget đổi kích thước ô
    run();
    if (retries >= 4) clearInterval(t);
  }, 1200);

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { schedule(); }, 250);
  }, { passive: true });
})();

/* ==========================================================================
   SZ REVIEW TRUNCATOR — parity 1:1 với cơ chế THẬT của tham chiếu Judge.me
   (almagems.com), đo lại 2026-09-17: KHÔNG dùng -webkit-line-clamp.
   Tham chiếu CẮT CHÍNH VĂN BẢN rồi chèn thẻ <a> "Read more" ngay cuối dòng
   chảy (computed: clamp none, maxHeight none, overflow visible,
   scrollHeight === clientHeight). Body 13px / line-height 18.46px, phần thu
   gọn cao 75px = 3 dòng chữ + "…", chữ "Read more" rơi xuống dòng 4.
   Ngân sách ký tự KHÔNG cố định: nó co giãn theo bề rộng card (~59-79 ký tự
   @390, ~145 @1440) nên ở đây ta ĐO hình học thật chứ không hardcode số ký tự.
   Bấm "Read more" => full text thay tại chỗ, card cao lên, nút biến mất.
   MỘT CHIỀU, không có "Read less" (đúng tham chiếu).
   ========================================================================== */
function szMakeTruncator(opts) {
  'use strict';
  var LINES = 3;                    // 3 dòng chữ; anchor tự rớt xuống dòng 4
  var BODY_SEL = '.jdgm-rev__body';
  var A_CLASS = 'jdgm-rev__body-read-more';
  var LABEL = 'Read more';
  var measurer = null;
  var busy = false;

  function getMeasurer() {
    if (measurer && measurer.parentNode) return measurer;
    measurer = document.createElement('div');
    measurer.setAttribute('aria-hidden', 'true');
    measurer.style.cssText =
      'position:absolute!important;left:-99999px!important;top:0!important;' +
      'visibility:hidden!important;pointer-events:none!important;' +
      'white-space:normal!important;overflow:visible!important;max-height:none!important;' +
      'min-height:0!important;height:auto!important;padding:0!important;margin:0!important;border:0!important;';
    document.body.appendChild(measurer);
    return measurer;
  }

  /* Sao chép đúng các thuộc tính chữ ảnh hưởng tới việc xuống dòng, và dùng
     bề rộng CONTENT-BOX thật của body để đo -> số ký tự cắt tự co theo card. */
  function syncMeasurer(body) {
    var m = getMeasurer();
    var c = window.getComputedStyle(body);
    var w = body.clientWidth -
            (parseFloat(c.paddingLeft) || 0) - (parseFloat(c.paddingRight) || 0);
    if (!(w > 20)) return null;
    m.style.width = w + 'px';
    m.style.font = c.font && c.font !== '' ? c.font : '';
    m.style.fontSize = c.fontSize;
    m.style.fontFamily = c.fontFamily;
    m.style.fontWeight = c.fontWeight;
    m.style.fontStyle = c.fontStyle;
    m.style.lineHeight = c.lineHeight;
    m.style.letterSpacing = c.letterSpacing;
    m.style.wordSpacing = c.wordSpacing;
    m.style.wordBreak = c.wordBreak;
    m.style.overflowWrap = c.overflowWrap;
    m.style.textTransform = c.textTransform;
    return { m: m, lh: parseFloat(c.lineHeight) || 18.46 };
  }

  function fits(m, text, maxH) {
    m.textContent = text;
    return m.scrollHeight <= maxH;
  }

  function makeAnchor() {
    var a = document.createElement('a');
    a.className = A_CLASS + (opts.extraAnchorClass ? ' ' + opts.extraAnchorClass : '');
    a.setAttribute('role', 'button');
    a.setAttribute('tabindex', '0');
    a.setAttribute('data-sz-rm', '1');
    a.textContent = LABEL;
    return a;
  }

  function expand(body) {
    var html = body.getAttribute('data-sz-html');
    if (html == null) return;
    body.setAttribute('data-sz-open', '1');
    body.classList.remove('is-truncated');
    body.innerHTML = html;                    // full text thay tại chỗ, nút biến mất
  }

  /* Idempotent: MỌI lần chạy đều dựng lại từ data-sz-html gốc nên không bao giờ
     đẻ ra 2 nút, kể cả sau sort / filter / phân trang / card nạp bằng AJAX. */
  function apply(body) {
    if (!body || body.getAttribute('data-sz-open') === '1') return;

    var full = body.getAttribute('data-sz-full');
    if (full === null) {
      var t = (body.textContent || '').replace(/\s+/g, ' ').trim();
      if (!t) return;                          // chưa có chữ -> để lượt sau, KHÔNG đánh dấu xong
      full = t;
      body.setAttribute('data-sz-full', full);
      body.setAttribute('data-sz-html', body.innerHTML);
    }

    var ctx = syncMeasurer(body);
    if (!ctx) return;                          // chưa layout (widget còn display:none) -> lượt sau
    var maxH = ctx.lh * LINES + 1;

    if (fits(ctx.m, full, maxH)) {             // review ngắn: KHÔNG có nút
      if (body.classList.contains('is-truncated') || body.getAttribute('data-sz-cut')) {
        body.removeAttribute('data-sz-cut');
        body.classList.remove('is-truncated');
        body.innerHTML = body.getAttribute('data-sz-html');
      }
      return;
    }

    // nhị phân theo RANH GIỚI TỪ: lấy đoạn dài nhất vẫn nằm trong 3 dòng
    var words = full.split(' ');
    var lo = 1, hi = words.length - 1, best = 1;
    while (lo <= hi) {
      var mid = (lo + hi) >> 1;
      if (fits(ctx.m, words.slice(0, mid).join(' ') + '…', maxH)) { best = mid; lo = mid + 1; }
      else hi = mid - 1;
    }
    var cut = words.slice(0, best).join(' ').replace(/[\s.,;:!?-]+$/, '') + '… ';
    if (body.getAttribute('data-sz-cut') === cut && body.classList.contains('is-truncated')) return;

    body.setAttribute('data-sz-cut', cut);
    body.innerHTML = '';
    body.appendChild(document.createTextNode(cut));
    body.appendChild(makeAnchor());
    body.classList.add('is-truncated');
  }

  function runOn(root) {
    if (!root || busy) return;
    busy = true;
    try {
      var bodies = root.querySelectorAll(BODY_SEL);
      for (var i = 0; i < bodies.length; i++) {
        try { apply(bodies[i]); } catch (e) { /* không bao giờ chặn Judge.me */ }
      }
    } catch (e) { /* noop */ } finally { busy = false; }
  }

  function bindOnce(root) {
    if (root.getAttribute('data-sz-rm-bound') === '1') return;
    root.setAttribute('data-sz-rm-bound', '1');
    // uỷ quyền sự kiện ở container -> sống sót mọi lần Judge.me dựng lại card
    root.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-sz-rm="1"]') : null;
      if (!a) return;
      e.preventDefault();
      e.stopPropagation();
      var body = a.closest('.jdgm-rev__body');
      if (body) expand(body);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var a = e.target && e.target.closest ? e.target.closest('[data-sz-rm="1"]') : null;
      if (!a) return;
      e.preventDefault();
      var body = a.closest('.jdgm-rev__body');
      if (body) expand(body);
    });
  }

  return {
    /* observer HẸP: chỉ container review, childList, rAF gộp nhịp, và NGẮT
       observer trong lúc ta tự ghi DOM -> không thể tự kích vòng lặp (bài học r10). */
    attach: function (root) {
      if (!root) return false;
      bindOnce(root);
      runOn(root);
      if (root.getAttribute('data-sz-rm-obs') !== '1') {
        root.setAttribute('data-sz-rm-obs', '1');
        var pending = false;
        var sweepTs = [];
        /* Judge.me nhả card thành NHIỀU nhịp (sort / lọc / phân trang / AJAX) và
           có lúc còn đang ẩn tạm -> đo ra bề rộng 0. Một lần chạy theo rAF là
           KHÔNG đủ: QC 2026-09-17 bắt được card 188 ký tự vẫn nguyên văn sau khi
           đổi sort. Nên sau mỗi đợt mutation ta quét lại vài nhịp thưa có giới hạn. */
        function sweepLater() {
          for (var i = 0; i < sweepTs.length; i++) clearTimeout(sweepTs[i]);
          sweepTs = [];
          var delays = [160, 600, 1500, 3000];
          for (var d = 0; d < delays.length; d++) {
            sweepTs.push(setTimeout(function () {
              mo.disconnect();
              runOn(root);
              mo.observe(root, { childList: true, subtree: true });
            }, delays[d]));
          }
        }
        var mo = new MutationObserver(function () {
          if (pending) return;
          pending = true;
          window.requestAnimationFrame(function () {
            pending = false;
            mo.disconnect();
            runOn(root);
            mo.observe(root, { childList: true, subtree: true });
            sweepLater();
          });
        });
        mo.observe(root, { childList: true, subtree: true });
        sweepLater();
        var rt;
        window.addEventListener('resize', function () {
          clearTimeout(rt);
          rt = setTimeout(function () {
            // đổi bề rộng => ngân sách ký tự đổi => dựng lại từ bản gốc
            var bodies = root.querySelectorAll('.jdgm-rev__body[data-sz-cut]');
            for (var i = 0; i < bodies.length; i++) bodies[i].removeAttribute('data-sz-cut');
            runOn(root);
          }, 220);
        }, { passive: true });
      }
      return true;
    },
    run: runOn
  };
}

/* ==========================================================================
   ROUND 3 — gắn truncator vào trang /pages/reviews
   AI Agent làm theo chỉ thị của anh Hoá — 2026-09-17 VN — WEB-20260917-suzitee-review-readmore
   Đã làm: thu gọn nội dung review về 3 dòng + "…" + "Read more" inline, đúng
   cơ chế THẬT của tham chiếu (cắt CHỮ chứ không -webkit-line-clamp). Trước:
   card hiện nguyên văn, cao thấp lệch nhau, không có nút. Sau: card đều nhịp,
   review ngắn KHÔNG có nút, review dài có nút; bấm là mở hẳn (một chiều).
   Gắn cho CẢ 2 tab (Product Reviews và Shop Reviews) vì cả hai đều nằm trong
   .jdgm-all-reviews__body / widget root, và chạy lại sau mỗi lần Judge.me dựng
   lại danh sách (sort / lọc / phân trang / đổi tab / card nạp bằng AJAX).
   Phạm vi: chỉ chạy khi có #judgeme_all_reviews_page — id này chỉ tồn tại ở
   templates/page.judgeme_all_reviews.liquid.
   ========================================================================== */
(function () {
  'use strict';
  try {
    var page = document.getElementById('judgeme_all_reviews_page');
    if (!page) return;
    var tr = szMakeTruncator({});
    var attached = false;

    function tryAttach() {
      var root = page.querySelector('.jdgm-all-reviews-widget') || page;
      if (!root) return false;
      // gắn 1 lần vào widget root: observer hẹp bên trong tự lo mọi lần rerender
      attached = tr.attach(root) || attached;
      return attached;
    }

    function start() {
      tryAttach();
      // widget Judge.me dựng bất đồng bộ + bỏ style ẩn tạm muộn -> thử lại có giới hạn
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        try { tryAttach(); tr.run(page); } catch (e) { /* noop */ }
        if (tries >= 12) clearInterval(iv);    // tối đa ~9.6s
      }, 800);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else { start(); }
  } catch (e) { /* không bao giờ chặn Judge.me */ }
})();
